import type { ContinuousScrollerFilter, ContinuousScrollerSort, DataGridColumnSettings } from '@myosh/odin-components';
import { t } from 'i18next';
import type { ViewColumn, ViewConfigArchivedType, ViewConfigDateRange } from '../../../../@types/views';
import {
  transformFilterDataToUpdateView,
  transformSortedFieldsToUpdateView,
} from '../../../../utils/dynamic-page-utils';

export const CREATE_NEW_VIEW = 'create_new_view';
export const SAVE_EXISTING_VIEW = 'save_existing_view';

export const getCreateUpdateOptions = () => [
  {
    text: t('create-new-view', 'Create new view'),
    value: CREATE_NEW_VIEW,
  },
  { text: t('save-as-existing-view', 'Save as existing view'), value: SAVE_EXISTING_VIEW },
];

export const archivedType: Record<string, ViewConfigArchivedType> = {
  false: 'NO',
  true: 'YES',
  both: 'ALL',
};

export const lastEditedType: Record<string, ViewConfigDateRange> = {
  thisMonth: 'THIS_MONTH',
  lastThreeMonths: 'LAST_THREE_MONTHS',
  lastSixMonths: 'LAST_SIX_MONTHS',
  thisYear: 'THIS_YEAR',
  all: 'ALL',
};

const viewReset = {
  sortSequence: undefined,
  sortColumn: false,
  ascending: false,
  stringFilter: undefined,
  firstDate: undefined,
  secondDate: undefined,
  firstValue: undefined,
  secondValue: undefined,
  multiselectRangeFilter: undefined,
  explicitShowAll: false,
};

export function mapViewColumn(
  isAllForms: boolean,
  view: Partial<ViewColumn>,
  dataGridColumn: DataGridColumnSettings,
  index: number,
  columnHasFilterSelected?: ContinuousScrollerFilter,
  columnHasSortedFilter?: ContinuousScrollerSort
) {
  if (view.entityReference && (columnHasFilterSelected || columnHasSortedFilter)) {
    let allDataGridFiltersOnAView = {};
    if (columnHasFilterSelected) {
      const viewWithFilters = transformFilterDataToUpdateView(
        view.entityReference.filterType,
        columnHasFilterSelected,
        isAllForms
      );
      allDataGridFiltersOnAView = { ...allDataGridFiltersOnAView, ...viewWithFilters };
    }
    if (columnHasSortedFilter) {
      const viewWithSortedFilter = columnHasSortedFilter
        ? transformSortedFieldsToUpdateView(columnHasSortedFilter)
        : undefined;
      allDataGridFiltersOnAView = { ...allDataGridFiltersOnAView, ...viewWithSortedFilter };
    }
    return {
      ...view,
      ...viewReset,
      ...allDataGridFiltersOnAView,
      includeArchived: dataGridColumn.includeArchived,
      position: index + 1,
    } as ViewColumn;
  }

  return {
    ...view,
    ...viewReset,
    includeArchived: dataGridColumn.includeArchived,
    position: index + 1,
  } as ViewColumn;
}
